<div [style]="style" #paypalRef></div>
